<script setup lang="ts">
// Outline flame — urgency chips ("Closes Soon"). Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M4.95833 8.45833C5.34511 8.45833 5.71604 8.30469 5.98953 8.0312C6.26302 7.75771 6.41667 7.38677 6.41667 7C6.41667 6.195 6.125 5.83333 5.83333 5.25C5.208 3.99992 5.70267 2.88517 7 1.75C7.29167 3.20833 8.16667 4.60833 9.33333 5.54167C10.5 6.475 11.0833 7.58333 11.0833 8.75C11.0833 9.28623 10.9777 9.81721 10.7725 10.3126C10.5673 10.808 10.2665 11.2582 9.88735 11.6374C9.50818 12.0165 9.05804 12.3173 8.56262 12.5225C8.06721 12.7277 7.53623 12.8333 7 12.8333C6.46377 12.8333 5.93279 12.7277 5.43738 12.5225C4.94196 12.3173 4.49182 12.0165 4.11265 11.6374C3.73347 11.2582 3.4327 10.808 3.22749 10.3126C3.02228 9.81721 2.91667 9.28623 2.91667 8.75C2.91667 8.07742 3.16925 7.41183 3.5 7C3.5 7.38677 3.65365 7.75771 3.92714 8.0312C4.20063 8.30469 4.57156 8.45833 4.95833 8.45833Z"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
  </svg>
</template>
